import { createStandardAction } from 'typesafe-actions'
import { CheckCategory } from '../document/types'
import { Locales } from '../session/types'
import { Toast, UndoReplacement } from './reducer'

export const SET_FILTERS = 'workspace/SET_FILTERS'
export const ADD_FILTER = 'workspace/ADD_FILTER'
export const SCROLL_SUGGESTION = 'workspace/SCROLL_SUGGESTION'

export const HARD_REDIRECT = 'workspace/HARD_REDIRECT'
export const SET_HAS_MAX_FREE_COMMENTS = 'workspace/SET_HAS_MAX_FREE_COMMENTS'
export const SWITCH_LOCALE = 'workspace/SWITCH_LOCALE'
export const SET_CURRENT_CATEGORY = 'workspace/SET_CURRENT_CATEGORY'
export const CHECK_INITIAL_CHECK_CATEGORY = 'workspace/CHECK_INITIAL_CHECK_CATEGORY'
export const SET_INITIAL_CATEGORY = 'workspace/SET_INITIAL_CATEGORY'
export const SET_GRAMMAR_CARD_CTA_INDEX = 'workspace/SET_GRAMMAR_CARD_CTA_INDEX'

export interface AddFilterMeta {
  type: string
  isRecheck?: boolean
}

export interface SuggestionPayload {
  index: number
}

export interface ScrollSuggestionPayload {
  increment: number
}

export interface HardRedirectPayload {
  url: string
}

export interface HardRedirectMeta {
  label?: string
}

export interface ShowToastPayload {
  toast: Toast
}

export interface SetHasMaxFreeCommentsPayload {
  value: boolean
}

export interface ShowUndoReplacementPayload {
  undo?: UndoReplacement
}

export interface SetGrammarCardCtaIndexPayload {
  ctaIndex: number
}

export interface SwitchLocalePayload {
  type: Locales
}

export interface SetCurrentCategoryPayload {
  checkCategory: CheckCategory
}

export const setCurrentCategory = createStandardAction(SET_CURRENT_CATEGORY)<
  SetCurrentCategoryPayload
>()

export const checkInitialCategory = createStandardAction(CHECK_INITIAL_CHECK_CATEGORY)()
export interface SetInitialCategoryPayload {
  checkCategory: CheckCategory
}

export const setInitialCategory = createStandardAction(SET_INITIAL_CATEGORY)<
  SetInitialCategoryPayload
>()

export const scrollSuggestion = createStandardAction(SCROLL_SUGGESTION)<
  ScrollSuggestionPayload
>()

export const hardRedirect = createStandardAction(HARD_REDIRECT)<
  HardRedirectPayload,
  HardRedirectMeta
>()

export const showToast = createStandardAction('workspace/SHOW_TOAST')<ShowToastPayload>()
export const clearToast = createStandardAction('workspace/CLEAR_TOAST')()

export const setHasMaxFreeComments = createStandardAction(SET_HAS_MAX_FREE_COMMENTS)<
  SetHasMaxFreeCommentsPayload
>()

export const showUndoReplacement = createStandardAction(
  'workspace/SHOW_UNDO_REPLACEMENT'
)<ShowUndoReplacementPayload>()
export const clearUndoReplacement = createStandardAction(
  'workspace/CLEAR_UNDO_REPLACEMENT'
)()

export const setGrammarCardCtaIndex = createStandardAction(SET_GRAMMAR_CARD_CTA_INDEX)<
  SetGrammarCardCtaIndexPayload
>()

export const switchLocale = createStandardAction(SWITCH_LOCALE)<SwitchLocalePayload>()

export const PAYMENT_FLOW_START = 'AUTH_FLOW_START'
export const PAYMENT_FLOW_END = 'AUTH_FLOW_END'
export const paymentFlowStart = createStandardAction(PAYMENT_FLOW_START)()
export const paymentFlowEnd = createStandardAction(PAYMENT_FLOW_END)()

const SET_NEW_UPLOAD = 'workspace/SET_NEW_UPLOAD'
export const setNewUpload = createStandardAction(SET_NEW_UPLOAD)<{ isNew: boolean }>()

export const promptLoginWithRedirect = createStandardAction(
  'workspace/PROMPT_LOGIN_WITH_REDIRECT'
)()



// WEBPACK FOOTER //
// ./src/state/workspace/actions.ts